module.exports = __webpack_public_path__ + "img/MANA.b57be103.svg";